import React, { useEffect } from 'react';
import './SuspensionModal.css';

interface SuspensionModalProps {
  motif?: string;
  depuis?: string;
  onLogout: () => void;
}

const SuspensionModal: React.FC<SuspensionModalProps> = ({ motif, depuis, onLogout }) => {
  // Empecher la touche Escape de fermer le modal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown, true);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="suspension-overlay">
      <div className="suspension-modal">
        {/* Header */}
        <div className="suspension-modal-header">
          <div className="suspension-modal-header-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <h2>Compte suspendu</h2>
        </div>

        {/* Body */}
        <div className="suspension-modal-body">
          <p className="suspension-text-primary">
            Votre organisme est actuellement suspendu.
          </p>
          <p className="suspension-text-secondary">
            L'accès à la plateforme Centralis est temporairement bloqué.
            Veuillez régulariser votre situation dans les meilleurs délais
            pour retrouver un accès complet à vos services.
          </p>

          {/* Motif */}
          {motif && (
            <div className="suspension-motif">
              <span className="suspension-motif-label">Motif</span>
              <span className="suspension-motif-text">{motif}</span>
            </div>
          )}

          {/* Date de suspension */}
          {depuis && (
            <div className="suspension-date">
              <span className="suspension-date-label">En vigueur depuis le</span>
              <span className="suspension-date-text">
                {new Date(depuis).toLocaleDateString('fr-FR', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </span>
            </div>
          )}

          {/* Contact */}
          <div className="suspension-contact">
            <p>Pour régulariser votre situation, contactez :</p>
            <a href="mailto:contact@centralis-europe.com" className="suspension-contact-link">
              contact@centralis-europe.com
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="suspension-modal-footer">
          <button className="suspension-logout-btn" onClick={onLogout}>
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspensionModal;
